// Client de catalogage : contrats validés, cache et mutations dans la portée de la galerie.
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { tableauCatalogageSchema } from '@artosera/shared';
import { api } from './client.js';
import { appelDeRequete, cleMetier, dansLaPortee } from './cles.js';
import { useMutation } from './mutation.js';

export function useCatalogage(g: string, cible?: { oeuvreId?: string; artisteId?: string }) {
  const params = new URLSearchParams(cible as Record<string, string>);
  return useQuery({
    queryKey: cleMetier(g, 'catalogage', cible ?? {}),
    queryFn: async (c) =>
      tableauCatalogageSchema.parse(
        await api.get(`/g/${encodeURIComponent(g)}/catalogage?${params}`, {
          galerie: g,
          ...appelDeRequete(c),
        }),
      ),
    refetchInterval: 10000,
  });
}

export function useGesteCatalogage(g: string) {
  const client = useQueryClient();
  return useMutation(
    dansLaPortee({
      mutationFn: (
        {
          chemin,
          corps,
          methode = 'post',
        }: { chemin: string; corps: unknown; methode?: 'post' | 'put' },
        appel,
      ) =>
        api[methode](`/g/${encodeURIComponent(g)}/catalogage/${chemin}`, corps, {
          galerie: g,
          ...appel,
        }),
      onSettled: async () => {
        await Promise.all(
          ['catalogage', 'oeuvres', 'artistes', 'ia'].map((cle) =>
            client.invalidateQueries({ queryKey: cleMetier(g, cle) }),
          ),
        );
      },
    }),
  );
}
